export default "/fonts/vendor/bootstrap-icons/bootstrap-icons.woff2?2b56e79ae5013246de291c3bd46c2c1b";